export default __webpack_public_path__ + "static/media/47017149cc68e7d0.9fa29a3e5e3f85e8b28ff37bc32e42e3.svg";